import { Outlet } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { GabrielChat } from "@/components/site/GabrielChat";

export const SiteLayout = () => (
  <div className="min-h-screen bg-white flex flex-col">
    <Header />
    <main className="flex-1">
      <Outlet />
    </main>
    <Footer />
    <GabrielChat />
  </div>
);
